export default __webpack_public_path__ + "static/media/logo2.bc05ae9b.png";